import React, { useEffect } from 'react';
import { useOpenPreviewPanel } from './useOpenPreviewPanel';
import { useOpenPreviewModal } from './useOpenPreviewModal';

export const PreviewPanelsPostMessageListener = () => {
	const { open } = useOpenPreviewPanel();
	const [currentUrl, setCurrentUrl] = React.useState('');
	const { actions, openModal } = useOpenPreviewModal(currentUrl);

	// Listen for messages from iframes to open preview panels
	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			const { payload } = event.data;

			if (event.data?.type === 'OPEN_EMBED_MODAL' && payload?.modal) {
				if (!actions || actions.length === 0) {
					setCurrentUrl(payload.modal.url);
					window.parent.postMessage(
						{
							type: 'OPEN_EMBED_MODAL',
							payload: payload,
						},
						'*',
					);
					return;
				}
				openModal();
				return;
			}

			// Only handle messages with the expected type
			if (event.data?.type !== 'OPEN_PREVIEW_PANEL') {
				return;
			}

			if (payload?.url) {
				open(payload);
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, [open, actions, openModal]);

	return null;
};
